// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function PrivateBenchmarkIdentifierFromJSON(json) {
    return {
        'uid': json['uid'],
        'isCustom': json['isCustom'],
    };
}
export function PrivateBenchmarkIdentifierToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'uid': value.uid,
        'isCustom': value.isCustom,
    };
}
